import { render, staticRenderFns } from "./AddUpBox.vue?vue&type=template&id=242a9708&"
import script from "./AddUpBox.vue?vue&type=script&lang=js&"
export * from "./AddUpBox.vue?vue&type=script&lang=js&"
import style0 from "./AddUpBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports